var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 65,
    viewBox: "0 0 63 65",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6874 17.7428L30.1249 32.4997M30.1249 32.4997L3.5624 17.7428M30.1249 32.4997L30.125 62.1873M36.375 60.2776L32.5532 62.4008C31.667 62.8932 31.2238 63.1394 30.7545 63.2359C30.3392 63.3213 29.9108 63.3213 29.4955 63.2359C29.0262 63.1394 28.5831 62.8932 27.6968 62.4008L4.57179 49.5536C3.6358 49.0336 3.16776 48.7736 2.82698 48.4038C2.52549 48.0766 2.29734 47.6889 2.15777 47.2665C2 46.789 2 46.2536 2 45.1828V19.8169C2 18.7461 2 18.2107 2.15776 17.7332C2.29734 17.3108 2.52549 16.923 2.82698 16.5959C3.16777 16.2261 3.63578 15.9661 4.57178 15.4461L27.6968 2.59885C28.583 2.10649 29.0262 1.86029 29.4955 1.76377C29.9108 1.67835 30.3392 1.67835 30.7545 1.76377C31.2238 1.86029 31.667 2.10648 32.5532 2.59884L55.6782 15.4461C56.6142 15.9661 57.0822 16.2261 57.423 16.5959C57.7245 16.923 57.9527 17.3108 58.0922 17.7332C58.25 18.2107 58.25 18.7461 58.25 19.8169L58.25 34.0623M16.0625 9.06234L44.1875 24.6873M52 60.6248V41.8748M42.625 51.2498H61.375",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIts);
export default __webpack_public_path__ + "static/media/its.b92d0a10d99d470202c99c5c7f1c6c4e.svg";
export { ForwardRef as ReactComponent };